import NewPage from './NewPage';

export default NewPage;
